<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <legend
    v-if="!!noLegend"
  >
    {{ 'Rental'|pgettext('Contract') }}
  </legend>
  <ItpFormGroup
    name="rental"
    :label="'Rental'|pgettext('Rental')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    :required="rentalRequired"
  >
    <ItpFormSelect2
      name="rental"
      :required="rentalRequired"
      v-model="rental"
      bind-object
      :dataSource="b_1040167445267876_dataSource"
      textField="number,name"
      clearable
      optionTemplate="<UcSuggestRentalOption :option=option></UcSuggestRentalOption>"
      use-option-template-for-selected-option
      @optionDeselected="evh_1040167445267876_optionDeselected($event, {})"
      @optionSelected="evh_1040167445267876_optionSelected($event, {})"
    >
    </ItpFormSelect2>
  </ItpFormGroup>
  <DIV
    v-if="contract.rental && contract.rental.id"
  >
    <ItpFormGroup
      name="name"
      :label="'Name'|pgettext('Rental')"
      labelColsMd="4"
      contentColsMd="8"
      :labelAlign="labelAlign"
    >
      <ItpFormInput
        name="name"
        v-model="contract.rental.name"
      >
      </ItpFormInput>
    </ItpFormGroup>
    <ItpFormGroup
      name="name"
      :label="'Address'|pgettext('Rental')"
      labelColsMd="4"
      contentColsMd="8"
      :labelAlign="labelAlign"
    >
      <ItpFormInput
        name="name"
        v-model="contract.rental.address"
      >
      </ItpFormInput>
    </ItpFormGroup>
    <ItpFormGroup
      name="area"
      :label="'Area'|pgettext('Rental')"
      labelColsMd="4"
      contentColsMd="4"
      :labelAlign="labelAlign"
    >
      <ItpFormInput
        name="name"
        v-model="contract.rental.area"
      >
      </ItpFormInput>
    </ItpFormGroup>
    <ItpFormGroup
      name="lot_number"
      :label="'LOT number'|pgettext('Rental')"
      labelColsMd="4"
      contentColsMd="4"
      :labelAlign="labelAlign"
    >
      <ItpFormInput
        name="name"
        v-model="contract.rental.lot_number"
      >
      </ItpFormInput>
    </ItpFormGroup>
    <ItpFormGroup
      name="house_number"
      :label="'House number'|pgettext('Rental')"
      labelColsMd="4"
      contentColsMd="4"
      :labelAlign="labelAlign"
    >
      <ItpFormInput
        name="name"
        v-model="contract.rental.house_number"
      >
      </ItpFormInput>
    </ItpFormGroup>
    <ItpFormGroup
      name="description"
      :label="'Description'|pgettext('Rental')"
      labelColsMd="4"
      contentColsMd="8"
      :labelAlign="labelAlign"
    >
      <ItpFormTextarea
        name="name"
        v-model="contract.rental.description"
      >
      </ItpFormTextarea>
    </ItpFormGroup>
  </DIV>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class FieldsetContractRentalData extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  contract!: object;

  @Watch('contract')
  onContract(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("contract")
  }

  @Prop({
    type: String,
    default: "right",
  })
  labelAlign!: string;

  @Watch('labelAlign')
  onLabel_align(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("labelAlign")
  }

  @Prop({
    type: Boolean,
  })
  noLegend!: boolean;

  @Watch('noLegend')
  onNo_legend(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("noLegend")
  }

  rental!: any;

  async $$load_rental() {
    return this.contract.rental || {}
  }

  ux!: any;
  b_1040167445267876_dataSource!: any;
  dataMembers = ['rental', 'ux', 'b_1040167445267876_dataSource'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        rental: null,
        ux: null,
        b_1040167445267876_dataSource: {
          name: "suggest_rental",
        }
        ,
      },
    }
  }

  get rentalRequired() {
    if (this.loaded) {

      return ['rental', 'rental_agreement', 'parking'].indexOf(this.contract.contract_type) > -1
    }
    return null;
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_setData_8710_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_1040167445267876_setData_8710, alias=undefined
    return {
      path: "contract.rental",
      value: null,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_1040167445267876_optionDeselected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_optionDeselected.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_setData_8714_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_1040167445267876_setData_8714, alias=undefined
    return {
      path: "contract.rental",
      value: $event.data.response.data,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_1040167445267876_request_8712_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_8712, alias=undefined
    return {
      operation: "read_rental",
      parameters: {
        id: $event.data.value.id,
      }
      ,
      headers: {
        accept: "application/vnd.itp.rentalparty+json",
      }
      ,
    }
  }

  async evh_1040167445267876_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_optionSelected.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_8708: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_8707: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_1040167445267876_setData_8710: actions.SetDataAction;
    evh_1040167445267876_optionDeselected_8709: actions.EventHandlerImpl;
    evh_1040167445267876_optionDeselected: actions.EventHandlerGroup;
    act_1040167445267876_setData_8714: actions.SetDataAction;
    evh_1040167445267876_success_8713: actions.EventHandlerImpl;
    act_1040167445267876_request_8712: actions.RequestAction;
    evh_1040167445267876_optionSelected_8711: actions.EventHandlerImpl;
    evh_1040167445267876_optionSelected: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_8708 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_8707 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_8708,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_8707],
      }
    );
    const act_1040167445267876_setData_8710 = new actions.SetDataAction(
      {
        actionArgs: this.act_1040167445267876_setData_8710_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_optionDeselected_8709 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_setData_8710,
        event: "optionDeselected",
        displayName: "setData",
      }
    );
    const evh_1040167445267876_optionDeselected = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_optionDeselected_8709],
      }
    );
    const act_1040167445267876_setData_8714 = new actions.SetDataAction(
      {
        actionArgs: this.act_1040167445267876_setData_8714_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_8713 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_setData_8714,
        event: "success",
        displayName: "setData",
      }
    );
    const act_1040167445267876_request_8712 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_8712_getActionArgs,
        events: [evh_1040167445267876_success_8713],
      }
    );
    const evh_1040167445267876_optionSelected_8711 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_8712,
        event: "optionSelected",
        displayName: "request",
      }
    );
    const evh_1040167445267876_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_optionSelected_8711],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_8708,
      evh_7315092382398562_reload_8707,
      evh_7315092382398562_reload,
      act_1040167445267876_setData_8710,
      evh_1040167445267876_optionDeselected_8709,
      evh_1040167445267876_optionDeselected,
      act_1040167445267876_setData_8714,
      evh_1040167445267876_success_8713,
      act_1040167445267876_request_8712,
      evh_1040167445267876_optionSelected_8711,
      evh_1040167445267876_optionSelected,
    }
  }
}

Vue.component("FieldsetContractRentalData", FieldsetContractRentalData);

</script>